module.exports = __webpack_public_path__ + "img/chat-gpt-integration-cover.cb971a31.webp";